import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">实时快讯</h2>
          <span className="flex items-center gap-1 text-xs text-primary-500 mt-1">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
            更新中
          </span>
        </div>

        <div className="max-w-[800px] mx-auto">
          {updateItems.map((item, idx) => (
            <div key={item.id} className="flex gap-4 group cursor-pointer">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-2.5 h-2.5 rounded-full mt-1.5 ${idx === 0 ? 'bg-primary-500 animate-pulse' : 'bg-background-300'}`}></div>
                {idx < updateItems.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 my-1"></div>
                )}
              </div>
              <div className={`pb-5 ${idx === updateItems.length - 1 ? '' : ''}`}>
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.time}</span>
                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${
                    item.tag === '最新' || item.tag === '突发' || item.tag === '独家'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '热议' || item.tag === '爆料'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}